import React from 'react';
import {AlternativeAutoComplete} from "common/form/autoComplete/_alternativeAutoComplete";
import { Option } from 'common/form/autoComplete/_option';
import {useQrCategoryTab} from "../../../../hook/useQrCategoryTab";

export const ProductCategory = () => {
  const {categoryFilter} = useQrCategoryTab()
  return (
    <AlternativeAutoComplete
      className="store-upos-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: {name: 'Danh mục cha', value: ''}, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 110,
        placeholder: 'Chọn danh mục cha',
        readOnly: true,
        value: categoryFilter?.value?.title || '',
        onIconClick: () => categoryFilter.onChange(null),
      }}
      // menu
      menuProps={{
        empty: categoryFilter?.list?.length <= 0 
                ? 'Không tìm thấy danh mục cha'
                : '',
      }}
      // search input in dropdown menu
      searchInputProps={{
        placeholder: 'Tìm kiếm danh mục cha',
        // value: categoryFilter.keyword,
        onChange: categoryFilter?.onKeywordChange,
      }}
    >
      {categoryFilter?.list?.length > 0 &&
        categoryFilter?.list?.map(item => (
        <Option
          key={item.id}
          className="store-upos-filter-form__option-text"
          data-active={item.id === categoryFilter.value?.id}
          onClick={() => categoryFilter.onChange(item)}
        >
          {item.title}
        </Option>
      ))}
    </AlternativeAutoComplete>
  )
}
